import React from 'react'
import Layout from '../../assets/Layout'
import UserLayout from '../../assets/UserLayout'
import { Box, Grid, TextField, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import CandidateCard from '../../assets/cards/CandidateCard';

export default function FavouriteCandidate({ candidates }) {
  return (
    <>
    <Layout>
        <UserLayout userRole={"employer"}>
        <Grid container mt={8}>
                    <Grid item md={8}>
                        <Typography className="heading1bold">
                        Favourite
                        </Typography>
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            sx={{
                                background: '#F8FAFF',
                                boxShadow: '0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014',
                                width:'100%'
                            }}
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                           
                        />
                    </Grid>
                </Grid>

                <Box    >
          <Grid container spacing={2} mb={10}>
          
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
                  <Grid item md={3}>
                    <CandidateCard />
                  </Grid>
        
          </Grid>
        </Box>
        </UserLayout>
        </Layout>
    </>
  )
}
